// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"modal_modalContainer__3c1Fg","modalTitle":"modal_modalTitle__dLues","modalDescription":"modal_modalDescription__g_okB","modalXButton":"modal_modalXButton__UpNW0"};